import type { IExternalDocSpec } from '../interfaces/quotes';
import { TRANSLATIONS_EXTERNAL_BENEFITS } from '../translations/commons';
import { QuoteDocumentType } from '../types/quotes';

const SPREADSHEET_EXTENSIONS = ['csv', 'xls', 'xlsx'] as const;

export const EXTENSIONS_BY_DOCUMENT_TYPE: Record<QuoteDocumentType, readonly string[]> = {
  [QuoteDocumentType.Demographics]: SPREADSHEET_EXTENSIONS,
  [QuoteDocumentType.EnrollmentReport]: SPREADSHEET_EXTENSIONS,
  [QuoteDocumentType.DemographicsWithDependents]: SPREADSHEET_EXTENSIONS,
  [QuoteDocumentType.Deductions]: SPREADSHEET_EXTENSIONS,
  [QuoteDocumentType.Sbc]: ['pdf'],
  [QuoteDocumentType.Other]: ['pdf', ...SPREADSHEET_EXTENSIONS, 'doc', 'docx']
};

export const MAX_FILE_BYTES = 4 * 1024 * 1024;

const acceptOf = (documentType: QuoteDocumentType): string =>
  EXTENSIONS_BY_DOCUMENT_TYPE[documentType].map((extension) => `.${extension}`).join(',');

const DOCS = TRANSLATIONS_EXTERNAL_BENEFITS.documents;

export const EXTERNAL_DOC_SPECS: readonly IExternalDocSpec[] = [
  {
    documentType: QuoteDocumentType.Demographics,
    titleKey: DOCS.demographics.title,
    descriptionKey: DOCS.demographics.description,
    accept: acceptOf(QuoteDocumentType.Demographics),
    extensions: EXTENSIONS_BY_DOCUMENT_TYPE[QuoteDocumentType.Demographics],
    multiple: false
  },
  {
    documentType: QuoteDocumentType.EnrollmentReport,
    titleKey: DOCS.enrollmentReport.title,
    descriptionKey: DOCS.enrollmentReport.description,
    accept: acceptOf(QuoteDocumentType.EnrollmentReport),
    extensions: EXTENSIONS_BY_DOCUMENT_TYPE[QuoteDocumentType.EnrollmentReport],
    multiple: false
  },
  {
    documentType: QuoteDocumentType.DemographicsWithDependents,
    titleKey: DOCS.demographicsWithDependents.title,
    descriptionKey: DOCS.demographicsWithDependents.description,
    accept: acceptOf(QuoteDocumentType.DemographicsWithDependents),
    extensions: EXTENSIONS_BY_DOCUMENT_TYPE[QuoteDocumentType.DemographicsWithDependents],
    multiple: false
  },
  {
    documentType: QuoteDocumentType.Deductions,
    titleKey: DOCS.deductions.title,
    descriptionKey: DOCS.deductions.description,
    accept: acceptOf(QuoteDocumentType.Deductions),
    extensions: EXTENSIONS_BY_DOCUMENT_TYPE[QuoteDocumentType.Deductions],
    multiple: false
  },
  {
    documentType: QuoteDocumentType.Sbc,
    titleKey: DOCS.sbc.title,
    accept: acceptOf(QuoteDocumentType.Sbc),
    extensions: EXTENSIONS_BY_DOCUMENT_TYPE[QuoteDocumentType.Sbc],
    multiple: true
  }
];

export const OTHER_DOC_SPEC: IExternalDocSpec = {
  documentType: QuoteDocumentType.Other,
  titleKey: DOCS.other.title,
  descriptionKey: DOCS.other.description,
  accept: acceptOf(QuoteDocumentType.Other),
  extensions: EXTENSIONS_BY_DOCUMENT_TYPE[QuoteDocumentType.Other],
  multiple: true
};
